<template>
  <div class="about">
    <h1>This is an about page1233</h1>
    <!-- <p v-show="userName">userName: {{ userName }}.</p> -->
    <div id="app-4">
      <ol>
        <li v-for="todo in tableList" >服务器数据:{{ todo.id }}</li>
      </ol>
      <button v-on:click="pageNumber += 1">Add 1</button>
      <button v-on:click="addMore(pageNumber += 1)">加载更多</button>

      <!-- <input
        class="file"
        name="file"
        type="file"
        accept="image/png, image/gif, image/jpeg"
        @getFile="update($event)"
      >-->
      <input type="file" @change="upload">
      <input type="file" @change="uploads" multiple="multiple">
    </div>
  </div>
</template>

<script>
import { getProductListPost } from "@/api/product";
import { getHolidayPost } from "@/api/holiday";
import { uploadFile } from "@/api/file";
import { uploadFiles } from "@/api/file";
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: "about",
  components: {},
  data() {
    return {
      tableList: [],
      pageSize: 10,
      pageNumber: 0,
      file: null,
      showProgress: false,
      uploadLoading: false,
      file: [],
      formData: new FormData(),
      queryKey:{
                title: 'f',
                year: 'u',
                type: 0,
                description: 'ck',
                goodsAttributes: [],
                goodsImages: [
                ],
                goodsRebates: []
            }
    }
  },
  // created() {console.log(this.$store.state.user.userName)},
  methods: {
    refreshTable() {
      // let form = new FormData();
      // form.append('name', '111');
      let queryData = Object.assign(this.queryKey)
      getHolidayPost(this.pageSize, this.pageNumber,queryData).then(res => {
        if (res && res.data.size > 0) {
          this.tableList = res.data.content;
        } else {
          this.$Message.error('数据错误')
        }
      })
    },
    addMore() {
      this.refreshTable()
    },
    upload(event) {

      // const file=e.target.files[0];

      // this.formData.append('file[]',file); // 'file[]' 代表数组 其中`file`是可变的

      this.file.push(event.target.files[0]);

      this.submit(event);
    },
    uploads(event) {

      // const file=e.target.files[0];


      // this.formData.append('file[]',event); // 'file[]' 代表数组 其中`file`是可变的
      event.preventDefault();
      for (let i = 0; i < event.target.files.length; i++) {
        this.formData.append('file', event.target.files[i]);
        this.file.push(event.target.files[i]);
      }


      uploadFiles(this.formData,this.userId).then(response => {
        console.log(response.data);
      }).catch(err => {
        console.log(err);
      })
      // this.submit(event);
    },
    getFile: function (event) {
      // 获取input里的文件
      this.file.push(event.target.files[0]);
      console.log(this.file);
    },
    submit: function (event) {
      event.preventDefault();
      // 创建form对象
      // 通过append向form对象添加数据
      // this.formData.append('name', this.name);
      // const file=event.target.files[0];
      this.formData = new FormData();
      this.formData.append('file', event.target.files[0]);
      uploadFile(this.formData,this.userId).then(response => {
        console.log(response.data);
      }).catch(err => {
        console.log(err);
      })
    }
  },
  mounted() {
    this.refreshTable()
  },
  computed: {
    ...mapState({
      userId: state => state.user.userId
    })
  }
};
</script>
<style lang='less' scoped>
</style>
